"use client";

import { Button } from "@repo/ui/button";
import { Input } from "@repo/ui/input";
import { Label } from "@repo/ui/label";
import { PasswordInput } from "@repo/ui/password-input";
import { useCallback, useState } from "react";
import { signIn } from "../../../../../lib/auth-client";
import { useRouter } from "next/navigation";
import { cn } from "../../../../../lib/utils";
import { MicrosoftSignInButton } from "../../../../../components/ui/microsoft-signin-button";
import { Separator } from "@repo/ui/separator";

export function SignInForm() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const router = useRouter();

  const login = useCallback(
    (e: React.ChangeEvent) => {
      e.preventDefault();
      const searchParams = new URLSearchParams(window.location.search);
      const redirect = searchParams.get("redirect") ?? "/files";

      signIn.email({
        email,
        password,
        fetchOptions: {
          onResponse: () => {
            setLoading(false);
          },
          onRequest: () => {
            setLoading(true);
          },
          onError: (ctx) => {
            setError(ctx.error.message);
          },
          onSuccess: async () => {
            router.push(redirect);
          },
        },
      });
    },
    [email, password],
  );

  return (
    <div>
      <form
        onSubmit={login}
        className="relative w-full max-w-[300px] lg:max-w-[500px]"
      >
        <h1 className="font-bold text-lg mb-4">Sign In</h1>
        <Label>Email</Label>
        <Input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          className="mt-1 mb-2"
          required
        />
        <Label>Password</Label>
        <PasswordInput
          className="mt-1 mb-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && (
          <div
            className="border border-red-600 bg-red-100 text-red-600 rounded-lg px-4 py-2 mb-2 mt-4 text-sm font-semibold"
            role="alert"
          >
            <p>{error}</p>
          </div>
        )}

        <Button
          className={cn("w-full mt-2", loading && "animate-pulse")}
          disabled={loading}
          type="submit"
        >
          Sign In
        </Button>
      </form>
      <div
        role="none"
        className="w-full flex items-center gap-2 my-4 text-muted"
      >
        <Separator className="shrink-[unset]! w-full" />
        <span className="uppercase text-xs tracking-wider font-semibold">
          or
        </span>
        <Separator className="shrink-[unset]! w-full" />
      </div>
      <div className="flex justify-center">
        <MicrosoftSignInButton className="w-full"></MicrosoftSignInButton>
      </div>
    </div>
  );
}
